import { object, string, number } from 'yup';

import { LOCATION_TYPE } from 'enum/location';
import { IP_TYPE } from 'enum/ip';
import IPValidator from 'utils/ipValidator';

export const validationSchema = object().shape({
  name: string()
    .trim()
    .max(250, 'Name cannot be more than 250 characters.')
    .min(3, 'Name cannot be less than 3 characters.')
    .required('Name is required'),
  category: string().required('Category is required'),
  type: string().oneOf(Object.values(IP_TYPE), 'Invalid IP type').required('IP Type is required'),
  address: string()
    .trim()
    .required('Address is required')
    // eslint-disable-next-line func-names
    .test('is-valid-ip', 'Invalid IP address', function (value) {
      let ipType = '4';
      const { type } = this.parent;
      if (type === IP_TYPE.IPv6) ipType = '6';
      else if (type === IP_TYPE.FQDN) ipType = 'fqdn';
      return IPValidator(value, ipType);
    }),
  description: string().optional().max(255, 'Description cannot be more than 255 characters'),
  location: string().oneOf(Object.values(LOCATION_TYPE)).required('Location type is required'),
  lat: number().when('location', {
    is: LOCATION_TYPE.COORDINATES,
    then: (schema) => schema.required('Latitude is required'),
    otherwise: (schema) => schema.optional(),
  }),
  lng: number().when('location', {
    is: LOCATION_TYPE.COORDINATES,
    then: (schema) => schema.required('Longitude is required'),
    otherwise: (schema) => schema.optional(),
  }),
});
